import { shuffle } from '../utils/shuffle'
import type { FilteknProduct } from '../types/snak'

export const products: FilteknProduct[] = [
  {
    id: 'supreme',
    headline: 'Meet Filtek Supreme.',
    name: 'Filtek Supreme',
    shortName: 'Supreme',
    traits: ['Precise', 'Detail-focused', 'Built for aesthetic control'],
    question: 'What does that sound like?',
    answer: 'firstborn',
    answerLabel: 'Firstborn',
    supporting: 'The one who likes things done properly.',
    closing: 'For cases where aesthetic control really matters.',
    accent: '#0F62AB',
  },
  {
    id: 'easyMatch',
    headline: 'Meet Filtek Easy Match.',
    name: 'Filtek Easy Match',
    shortName: 'Easy Match',
    traits: ['Simple', 'Adaptable', 'Easy to get along with'],
    question: 'What does that sound like?',
    answer: 'middle',
    answerLabel: 'Middle child',
    supporting: 'Good at adapting without making things complicated.',
    closing:
      'Designed around everyday simplicity and intuitive shade matching.',
    accent: '#6E4A9E',
  },
  {
    id: 'oneBulkFill',
    headline: 'Meet Filtek One Bulk Fill.',
    name: 'Filtek One Bulk Fill',
    shortName: 'One Bulk Fill',
    traits: ['Fast', 'Practical', 'Gets things done'],
    question: 'Which sibling does that sound like?',
    answer: 'youngest',
    answerLabel: 'Youngest',
    supporting:
      'Less interested in tradition. More interested in getting there efficiently.',
    closing: 'Designed for posterior efficiency and simplicity.',
    accent: '#05dd4d',
  },
  {
    id: 'warmer',
    headline: 'And then, years later... the Composite Warmer.',
    name: 'Filtek Composite Warmer',
    shortName: 'Composite Warmer',
    traits: ['Arrived last', 'Warm', 'Makes everyone else flow better'],
    question: 'Which sibling does that sound like?',
    answer: 'caboose',
    answerLabel: 'The caboose child',
    supporting:
      'Turned up long after everyone assumed the family was finished — and somehow the whole family works better now.',
    closing:
      'Warms indicated Filtek restoratives in as little as two minutes: better flow, improved adaptation, fewer voids, less extrusion force.',
    accent: '#E2703A',
  },
]

/**
 * A fresh introduction order for each run, so the story never opens on the
 * same sibling twice in a row. The caboose stays last — arriving late is
 * the whole point of them.
 */
export function introOrder(): FilteknProduct[] {
  const late = products.filter((p) => p.answer === 'caboose')
  const rest = products.filter((p) => p.answer !== 'caboose')
  return [...shuffle(rest), ...late]
}
